import React, {useEffect, useState} from "react";
import {
    Button, Icon,
    Input,
    InputGroup,
    InputLeftElement, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup,
} from "@chakra-ui/react";
import {ChevronDownIcon, SearchIcon} from "@chakra-ui/icons";
import {FaCreditCard} from "react-icons/fa";

const mapFieldToUi = {
    "search": {
        icon: <SearchIcon/>,
        placeholder: "id txid outertxid..."
    },
    "tokenCard": {
        icon: <Icon as={FaCreditCard}/>,
        placeholder: "id txid outertxid..."
    }
};

export function SearchTransaction({onChange}){
    const [query, setQuery] = useState("");
    const [field, setField] = useState("search")
    const [displayMessage, setDisplayMessage] = useState({[field]: query});
    useEffect(() => {
        const timeOutId = setTimeout(() => setDisplayMessage({
            search: "",
            tokenCard: "",
            [field]: query
        }), 500);
        return () => clearTimeout(timeOutId)
    }, [query, field]);

    useEffect(() => {
        onChange(displayMessage)
    }, [displayMessage]);

    return (
        <InputGroup
            borderRadius="15px"
            w="420px"
            _focus={{
                // borderColor: { mainTeal },
            }}
            _active={{
                // borderColor: { mainTeal },
            }}
        >
            <InputLeftElement width="72px">
                <Menu closeOnSelect={false}>
                    <MenuButton as={Button} variant="ghost"
                                leftIcon={mapFieldToUi[field].icon}
                                rightIcon={<ChevronDownIcon/>}
                                borderLeftRadius="15px"
                                borderRightRadius="0"
                    >
                    </MenuButton>
                    <MenuList>
                        <MenuOptionGroup type="radio" value={field} onChange={setField}>
                            <MenuItemOption value="search">По id, txid или outertxid</MenuItemOption>
                            <MenuItemOption value="tokenCard">По токену карты</MenuItemOption>
                        </MenuOptionGroup>
                    </MenuList>
                </Menu>
            </InputLeftElement>
            <Input
                id="message"
                fontSize="xs"
                onChange={(e) => setQuery(e.target.value)}
                pl="76px"
                py="11px"
                borderRadius="inherit"
                placeholder={mapFieldToUi[field].placeholder}
            />
        </InputGroup>

    );
}
